{
  "patliteEditDialog": {
    "title": "パトライト設定",
    "text": "エリア:",
    "label": "通知対象ユーザー（複数選択可）",
    "placeholder": "ユーザーを選択"
  },
  "patliteFilterBar": {
    "placeholder": "エリア名、カメラ名で検索",
    "label": "並び順"
  },
  "patliteState": {
    "createdAtDesc": "検知新着順",
    "areaAsc": "エリア名昇順"
  },
  "patliteTable": {
    "label": "エリア",
    "label2": "最新検知時刻",
    "label3": "検知前",
    "label4": "検知後",
    "text": "エラーが発生しました",
    "text2": "閲覧可能な検知はありません"
  },
  "usePatliteViewState": {
    "enqueueSnackbar": "設定を更新しました。",
    "enqueueSnackbar2": "設定更新に失敗しました。"
  },
  "patlite": {
    "title": "パトライト管理"
  }
}
